import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenUuidExwork, OpenUuidExworkPhase } from '@shared/src/controllers/open/OpenUuidExwork';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { HTags } from '@shared/src/datatypes/HTags';
import { BookingSimpleDto } from '@shared/src/dtos/booking/BookingSimpleDto';
import { OpenRouteChangeDriverInfoAndPlatesDto } from '@shared/src/dtos/open/OpenRouteChangeDriverInfoAndPlatesDto';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { HTagsDefined } from '@shared/src/enums/HTagsDefined';
import { AlertService, SharedSaveButtonEvent } from '@shared/src/public-api';

@Component({
    selector: 'shared-driver-driverplate-edit-component',
    templateUrl: './shared.driver.driverplate.edit.component.html',
    styleUrls: ['./shared.driver.driverplate.edit.component.scss']
})
export class SharedDriverDriverPlateEditComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteController: OpenRouteController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
        this.getDades();
    }

    @Input()
    public driver: boolean = false;

    public __uuidExwork: string;
    @Input()
    public set uuidExwork(value: string) {
        if (this.__uuidExwork == value)
            return;
        this.__uuidExwork = value;
    }
    public get uuidExwork(): string {
        return this.__uuidExwork;
    }

    public __phase: PhaseCardItemDto;
    @Input()
    public set phase(value: PhaseCardItemDto) {
        if (this.__phase == value)
            return;
        this.__phase = value;
    }
    public get phase(): PhaseCardItemDto {
        return this.__phase;
    }

    public viewToShow: string = "general";

    public showNoRequiresSlot: boolean = false;
    public data: OpenUuidExwork;
    public uniquePhase: OpenUuidExworkPhase;
    public paneDretaObert: boolean = true;
    @Output()
    slotChanged: EventEmitter<void> = new EventEmitter();
    public getDades() {
        this.getExwork();
        this.slotChanged.next();
    }

    getExwork() {
        this.openRouteController.getDriverExwork(this.__uuidExwork).subscribe(d => {
            this.data = d;
        });
    }
    public onRouteBookingRefreshData($event: BookingSimpleDto) {
        this.getExwork();
    }

    public algoAFer(): boolean {
        if (this.data && this.data.phaseList && this.data.phaseList.length > 0)
            return true;
        return false;
    }

    public esBooking(): boolean {
        if (this.data != null)
            if (HTags.contains(this.data.internalTags, HTagsDefined.HTAG_requiresBooking))
                return true;
        return false;
    }

    public requereixBooking(): boolean {
        if (this.esBooking())
            if (this.data != null && (this.data.bookingId == null || this.data.bookingId == 0))
                return true;

        return false;
    }
    public editMode: boolean = false;
    public plateA: string;
    public plateB: string;
    public plateC: string;
    public transportationRegistrationCode: string;
    public driverName: string;
    public driverLegalIdentification: string;
    public driverPhone: string;
    public carrierName: string;
    public carrierCode: string;
    public carrierLegalIdentification: string;
    public carrierAddress: string;
    public startEditmode() {
        this.editMode = true;

        this.plateA = this.data.plateA;
        this.plateB = this.data.plateB;
        this.plateC = this.data.plateC;
        this.transportationRegistrationCode = this.data.transportationRegistrationCode;
        this.driverName = this.data.driverName;
        this.driverLegalIdentification = this.data.driverLegalIdentification;
        this.driverPhone = this.data.driverPhone;
        this.carrierCode = this.data.carrierCode;
        this.carrierName = this.data.carrierName;
        this.carrierLegalIdentification = this.data.carrierLegalIdentification;
        this.carrierAddress = this.data.carrierAddress;
    }

    public cancel(){
        this.editMode = false;
    }

    save($event: SharedSaveButtonEvent) {
        this.openRouteController.setDriverDriverInfoAndPlates(this.uuidExwork,
            OpenRouteChangeDriverInfoAndPlatesDto.build(this.driverName, this.driverLegalIdentification, this.driverPhone, this.plateA, this.plateB, this.plateC, this.transportationRegistrationCode, this.carrierCode, this.carrierName, this.carrierLegalIdentification, this.carrierAddress)).subscribe(data => {
                this.editMode = false;
                this.getDades();
                if ($event)
                    $event.callback();
            });
    }

    call(phone: string) {
        /* window.open(phone); */
        window.location.href = 'tel:' + phone;
    }
    copy(text: string) {
        this.alertService.copyToClipboard(text).subscribe();
    }

    onClickOption(option: string) {
        if (option == null || option == "") {
            this.viewToShow = "general";
        }
        this.viewToShow = option;
    }

    goToNormal() {
        this.viewToShow = 'general';
        this.getExwork();
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
